import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../LanguageContext';
import useSite from '../useSite';
import './HomeHero.css';

const T = {
  h1:   { ko: <>IoT 기술로 알아보는<br/>스마트 헬스케어의 미래</>,
          en: <>Smart Healthcare,<br/>Powered by IoT</> },
  sub:  { ko: <>IoT 센서와 실시간 모니터링으로<br/>더 편안하고 정확한 돌봄을 제공합니다.</>,
          en: <>IoT sensors and real-time monitoring deliver care<br/>that is more comfortable and more precise.</> },
  cta1: { ko: '스마트 기저귀 알아보기', en: 'Explore Smart Diaper' },
  cta2: { ko: '도입 상담 신청',        en: 'Request a Consultation' },
  s1:   { ko: '도입 기관',       en: 'Facilities' },
  s2:   { ko: '누적 교체 감지',   en: 'Changes Detected' },
  s3:   { ko: '실시간 모니터링',  en: 'Real-Time Monitoring' },
  s4:   { ko: '등록 특허',       en: 'Patents' },
  alt:  { ko: '요양시설에서 어르신을 돌보는 간호사와 메디로지스 IoT 중계기',
          en: 'A nurse caring for a resident with a MEDILOGIS IoT repeater' },
};

// 등록 특허 수는 SITE_CONFIG(patents) 에서 관리한다. 못 읽으면 4.
const PATENTS_FALLBACK = 4;

const Icon = {
  building: <svg fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24"><path d="M3 21h18M5 21V7l7-4 7 4v14M9 9h.01M9 13h.01M9 17h.01M15 9h.01M15 13h.01M15 17h.01"/></svg>,
  bell:     <svg fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 0 1-3.4 0"/></svg>,
  monitor:  <svg fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24"><rect height="14" rx="2" width="20" x="2" y="4"/><path d="M8 22h8M12 18v4M6 11h3l2-3 2 5 2-2h3"/></svg>,
  medal:    <svg fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24"><circle cx="12" cy="9" r="6"/><path d="m8.5 14-1.5 7 5-3 5 3-1.5-7"/></svg>,
  chevron:  <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="m6 9 6 6 6-6"/></svg>,
};

function HomeHero({ heroImage }) {
  const { lang } = useLang();
  // 하드코딩하지 않는다 — serve.js /api/stats (5분 캐시 내장)
  const [stats, setStats] = useState(null);
  const cfg = useSite('/api/site/config', null);
  const patents = (cfg && cfg.patents && cfg.patents.ko) || PATENTS_FALLBACK;

  useEffect(() => {
    let alive = true;
    fetch('/api/stats')
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (alive && d) setStats(d); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  // 값을 못 받으면 숫자를 지어내지 않고 자리만 비운다
  const fmt = (n) => (typeof n === 'number' ? n.toLocaleString('ko-KR') : '—');

  return (
    <div className="fv">
      <div className="fv-hero">
        <div className="fv-copy">
          <h1>{T.h1[lang]}</h1>
          <p className="fv-sub">{T.sub[lang]}</p>
          <div className="fv-cta">
            {/* 예전 메인의 섹션 id(#products)를 가리키고 있어 눌러도 아무 일이 없었다 */}
            <Link className="fv-btn primary" to="/solution/intro">{T.cta1[lang]}</Link>
            <Link className="fv-btn ghost" to="/support/inquiry">{T.cta2[lang]}</Link>
          </div>
        </div>
        <div className="fv-media">
          {heroImage && <img src={heroImage} alt={T.alt[lang]} />}
        </div>
      </div>

      <div className="fv-strip">
        <div className="fv-stat">
          {Icon.building}
          <div><div className="num">{fmt(stats && stats.hospital)}</div><div className="lbl">{T.s1[lang]}</div></div>
        </div>
        <div className="fv-stat">
          {Icon.bell}
          <div><div className="num">{fmt(stats && stats.total)}</div><div className="lbl">{T.s2[lang]}</div></div>
        </div>
        <div className="fv-stat">
          {Icon.monitor}
          <div><div className="txt">{T.s3[lang]}</div></div>
        </div>
        <div className="fv-stat">
          {Icon.medal}
          <div><div className="num">{patents}</div><div className="lbl">{T.s4[lang]}</div></div>
        </div>
      </div>

      <div className="fv-cue" aria-hidden="true">
        SCROLL
        {Icon.chevron}
      </div>
    </div>
  );
}

export default HomeHero;
